import { createContext } from 'react';
import { DataVendor } from 'v2/models';

export interface DataVendorContextValue {
  dataVendor?: DataVendor;
  refetch?: () => void;
  refetchDataVendor?: () => void;
}

export const DataVendorContext = createContext<DataVendorContextValue>(
  {} as DataVendorContextValue
);
